import { render, staticRenderFns } from "./TradeTransferActions.vue?vue&type=template&id=4bd0cf6b&scoped=true&"
import script from "./TradeTransferActions.vue?vue&type=script&lang=js&"
export * from "./TradeTransferActions.vue?vue&type=script&lang=js&"
import style0 from "./TradeTransferActions.vue?vue&type=style&index=0&id=4bd0cf6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0cf6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd0cf6b')) {
      api.createRecord('4bd0cf6b', component.options)
    } else {
      api.reload('4bd0cf6b', component.options)
    }
    module.hot.accept("./TradeTransferActions.vue?vue&type=template&id=4bd0cf6b&scoped=true&", function () {
      api.rerender('4bd0cf6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/StatusAccountHistory/TradeTransferActions.vue"
export default component.exports